// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bx9dtCBYFXkn5oHGx1xM{min-width:44px;display:-webkit-box;display:-ms-flexbox;display:flex}html[dir] .qrdN3BxYsigEYOd2EN1M{-webkit-transform:unset!important;transform:unset!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bigHoverActionContainer": "bx9dtCBYFXkn5oHGx1xM",
	"animatedBigHoverAction": "qrdN3BxYsigEYOd2EN1M"
};
module.exports = ___CSS_LOADER_EXPORT___;
